export const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4']

/** Visible category-label characters before the ellipsis; tooltips retain the full name. */
export const INITIATIVES_CHART_LABEL_MAX_LENGTH = 17
